import { useLayoutEffect } from 'react';
import type { RefObject } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Light reveals for sub pages: [data-fade] (0.6s fade-up) and [data-clip] (same clip reveal as home).
 * Animation only — scroll position is owned by ScrollManager. Respects reduced motion.
 */
export default function useLightReveal(ref: RefObject<HTMLElement | null>, key: string) {
  useLayoutEffect(() => {
    if (!ref.current || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const ctx = gsap.context(() => {
      gsap.utils.toArray<HTMLElement>('[data-fade]').forEach((el) => {
        gsap.from(el, { y: 14, opacity: 0, duration: 0.6, ease: 'power2.out', scrollTrigger: { trigger: el, start: 'top 92%', once: true } });
      });
      gsap.utils.toArray<HTMLElement>('[data-clip]').forEach((el) => {
        gsap.from(el, { clipPath: 'inset(12% 0% 12% 0%)', duration: 0.9, ease: 'power2.out', scrollTrigger: { trigger: el, start: 'top 90%', once: true } });
      });
    }, ref);
    const raf = window.requestAnimationFrame(() => ScrollTrigger.refresh());
    return () => { window.cancelAnimationFrame(raf); ctx.revert(); };
  }, [ref, key]);
}